export const types = {
    ASSIGN: 'ASSIGN',
    SELECT:'SELECT',
    REMOVE:'REMOVE',
    SIZE:'SIZE',
    UPDATE:'UPDATE'
};
